import { SharedTftSalesLeads } from "@app/shared";

const TftSalesLeads = () => {
  return <SharedTftSalesLeads />;
};

export default TftSalesLeads;
